import { render } from "./PriorityBlock.vue?vue&type=template&id=13455fb6&scoped=true&ts=true"
import script from "./PriorityBlock.vue?vue&type=script&lang=ts"
export * from "./PriorityBlock.vue?vue&type=script&lang=ts"

import "./PriorityBlock.vue?vue&type=style&index=0&id=13455fb6&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13455fb6"]])

export default __exports__